module.exports = __webpack_public_path__ + "img/banner-right.4ab0cb2c.png";